import React, { useCallback, useEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";
import Select from "react-select";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import { LuDownload } from "react-icons/lu";
import { FaEye } from "react-icons/fa";
import { toast } from "react-toastify";
import ApiService from "../../services/ApiService";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Paginator from "../../components/Paginator";
import Lottie from "lottie-react";
import NoResultAnimation from "../../assets/animations/No Result Green theme.json"
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";

const Transaction = () => {
  const [showDetailsModal, setShowDetailsModal] = useState(false);
const [selectedTransaction, setSelectedTransaction] = useState(null);
console.log("oajoasdnklandkla",selectedTransaction)
const fetchTransactionDataDebounced = useCallback(
  debounce((appliedFilters) => {
    fetchTransactionData(1, appliedFilters);
  }, 500),
  []
);
      const { t, i18n } = useTranslation();




  const [transactionData, setTransactionData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({
    total_pages: 1,
    current_page: 1,
  });

  useEffect(() => {
    fetchTransactionData(1);
  }, []);

  console.log("Dashboard Data:", transactionData);
  const [filters, setFilters] = useState({
    search: "",
    pay_status: "",
    payment_method: "",
    daterange: { from: null, to: null },
  });
  
 const fetchTransactionData = async (page = 1, appliedFilters = filters) => {
  try {
    const params = new URLSearchParams();
    params.append("page", page);

    if (appliedFilters.search) params.append("search", appliedFilters.search);
    if (appliedFilters.pay_status) params.append("pay_status", appliedFilters.pay_status);
    if (appliedFilters.payment_method) params.append("payment_method", appliedFilters.payment_method);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`; // YYYY-MM-DD
    };

    if (appliedFilters.daterange.from) {
      const from = formatDate(appliedFilters.daterange.from);
      if (from) params.append("daterange[from]", from);
    }

    if (appliedFilters.daterange.to) {
      const to = formatDate(appliedFilters.daterange.to);
      if (to) params.append("daterange[to]", to);
    }

    setIsLoading(true);
    const res = await ApiService.request({
      method: "GET",
      url: `company/getTransactions?${params.toString()}`,
    });

    const data = res.data;
    if (data.status) {
      setTransactionData(data?.data?.projects);
      setPagination(data?.data?.pagination ? data?.data?.pagination : 1);
    } else {
      setTransactionData([]); // clear old data
      toast.error(data.message || "No transactions found");
    }
  } catch (err) {
    console.error("Fetch Transaction Error:", err);
    toast.error("Failed to fetch transactions.");
  } finally {
    setIsLoading(false);
  }
};

  const handlePageChange = (page) => {
    if (
      page !== pagination.current_page &&
      page >= 1 &&
      page <= pagination.total_pages
    ) {
      fetchTransactionData(page);
    }
  };

  const { current_page, total_pages } = pagination;

  // Generate page numbers (for large datasets show 1,2,3,...,last)
  const getPages = () => {
    const pages = [];

    if (total_pages <= 5) {
      for (let i = 1; i <= total_pages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (current_page > 3) {
        pages.push("...");
      }
      for (
        let i = Math.max(2, current_page - 1);
        i <= Math.min(total_pages - 1, current_page + 1);
        i++
      ) {
        pages.push(i);
      }
      if (current_page < total_pages - 2) {
        pages.push("...");
      }
      pages.push(total_pages);
    }

    return pages;
  };

  const pages = getPages();

  function formatSingleDate(isoDate) {
    const date = new Date(isoDate);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" }); 
    return `${day} ${month}`;
  }
const fieldBgColor = "white"; 
  const optionHoverColor = "rgba(65, 19, 24, 0.08)"; 
const handleClearFilters = () => {
  const clearedFilters = {
    search: "",
    pay_status: "",
    payment_method: "",
    daterange: { from: null, to: null },
  };

  setFilters(clearedFilters);
  fetchTransactionData(1, clearedFilters); 
};

      const isRTL = i18n.language === 'ar';

  return (
    <div className="inter-font " style={{ minHeight: "100vh" }}>
      <div className="inter-font d-flex justify-content-between align-items-center flex-wrap px-3">
        <h2 className="inter-font inter-font" style={{ fontSize: "19px" }}>
          {t("c_tra_title")}
        </h2>
      </div>

      {/* Search */}
      <div className="inter-font position-relative mb-3">
        {isRTL ?  <CiSearch
                          className="inter-font position-absolute"
                          style={{
                            right: "12px",
                            top: "50%",
                            transform: "translateY(-50%) scaleX(-1)",
                            pointerEvents: "none",
                          }}
                          size={20}
                        /> : null }
        <input
          type="text"
          placeholder={t("c_ff_text65")}
          className={`inter-font w-100 p-2 rounded-3  py-3 ${isRTL ? 'pe-5' : 'ps-5'} `}
          style={{ paddingLeft: "2.5rem", border: "none" }}
          value={filters.search}
           onChange={(e) => {
    const newFilters = { ...filters, search: e.target.value };
    setFilters(newFilters);
    fetchTransactionDataDebounced(newFilters);
  }}
        />
       {isRTL ? null : <CiSearch
              className="position-absolute"
              style={{
                left: "16px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#666",
              }}
              size={20}
            />}
      </div>

<div className="inter-font d-flex flex-wrap gap-2 mb-3 align-items-center">

  {/* Payment Status */}
  <div style={{ flex: "1 1 150px", minWidth: "150px" }}>
    <Select
      options={[
        { value: "Paid", label: t("c_ff_text98") },
        { value: "Failed", label: t("c_ff_text96") },
      ]}
      placeholder={t("new_text_57")}
      isClearable
      value={[
        { value: "Paid", label: t("c_ff_text98") },
        { value: "Failed", label: t("c_ff_text96") },
      ].find((o) => o.value === filters.pay_status) || null}
      onChange={(opt) => setFilters({ ...filters, pay_status: opt?.value || "" })}
      styles={{
        control: (base) => ({
          ...base,
          height: 40,
          minHeight: 40,
          fontSize: 14,
          borderRadius: 8,
          border: "none",
          boxShadow: "none",
          backgroundColor: fieldBgColor,
        }),
        valueContainer: (base) => ({ ...base, padding: "0 10px" }),
        placeholder: (base) => ({ ...base, color: "#6c757d" }),
        menu: (base) => ({ ...base, borderRadius: 8, fontSize: 14 }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isFocused ? optionHoverColor : "white",
          color: "#212529",
          padding: "8px 10px",
          cursor: "pointer",
        }),
      }}
    />
  </div>

  {/* Payment Method */}
  <div style={{ flex: "1 1 150px", minWidth: "150px" }}>
    <Select
      options={[
        { value: "Card", label: "Card" },
        { value: "Apple_Pay", label: "Apple Pay" },
      ]}
      placeholder={t("c_s_tab3")}
      isClearable
      value={[
        { value: "Card", label: "Card" },
        { value: "Apple_Pay", label: "Apple Pay" },
      ].find((o) => o.value === filters.payment_method) || null}
      onChange={(opt) => setFilters({ ...filters, payment_method: opt?.value || "" })}
      styles={{
        control: (base) => ({
          ...base,
          height: 40,
          minHeight: 40,
          fontSize: 14,
          borderRadius: 8,
          border: "none",
          boxShadow: "none",
          backgroundColor: fieldBgColor,
        }),
        valueContainer: (base) => ({ ...base, padding: "0 10px" }),
        placeholder: (base) => ({ ...base, color: "#6c757d" }),
        menu: (base) => ({ ...base, borderRadius: 8, fontSize: 14 }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isFocused ? optionHoverColor : "white",
          color: "#212529",
          padding: "8px 10px",
          cursor: "pointer",
        }),
      }}
    />
  </div>

  {/* Date Range */}
 {/* Date Range */}
<div style={{ flex: "1 1 250px", minWidth: "250px" }}>
  <DateRangePicker
    initialSettings={{ minDate: moment().startOf("day") }}
    onApply={(event, picker) => {
      setFilters({
        ...filters,
        daterange: {
          from: picker.startDate.toDate(),
          to: picker.endDate.toDate(),
        },
      });
    }}
    autoUpdateInput={false}
    opens="right"
  >
    <input
      type="text"
      className="form-control"
      placeholder={t("new_text_49")}
      style={{
        height: "40px",
        fontSize: 14,
        padding: "0 10px",
        borderRadius: 8,
        border: "none",
        backgroundColor: fieldBgColor, // same as search input
        boxShadow: "none", // remove input box shadow
      }}
      value={
        filters.daterange.from && filters.daterange.to
          ? `${filters.daterange.from.toLocaleDateString()} - ${filters.daterange.to.toLocaleDateString()}`
          : ""
      }
      readOnly
    />
  </DateRangePicker>

  <style jsx global>{`
  .daterangepicker input::placeholder {
      color: #6c757d; 
      opacity: 1; 
    }
    .daterangepicker {
      box-shadow: none !important; 
      border: 1px solid transparent; 
      background-color: ${fieldBgColor};
    }
  `}</style>
</div>

  {/* Search Button */}
  <button
    className="btn d-flex align-items-center justify-content-center gap-1"
    style={{
      background: "rgba(205, 73, 109, 1)",
      color: "white",
      padding: "0 18px",
      border: "none",
      borderRadius: 8,
      height: 40,
      fontSize: 14,
    }}
    onClick={() => fetchTransactionData(1)}
  >
   {isRTL ? null : <CiSearch size={18} />} 
                             {isRTL ?  <CiSearch
                                       style={{
                                         transform: " scaleX(-1)",
                                       }}
                                       size={18}
                                     /> : null } 
           {t("c_ff_text66")}
  </button>

  {/* Clear Button */}
  <button
    className="btn d-flex align-items-center justify-content-center gap-1"
    style={{
      background: "rgba(108, 117, 125, 0.9)",
      color: "white",
      padding: "0 18px",
      border: "none",
      borderRadius: 8,
      height: 40,
      fontSize: 14,
    }}
    onClick={handleClearFilters}
  >
    {t("c_ff_text67")} 
  </button>
</div>


      {/* Table */}
      <Container className="inter-font bg-white rounded-4 mt-4 p-0 px-0 overflow-hidden">
        {isLoading ? (

          <div className="text-center my-4">
          <p>Loading…</p>
        </div>
        ) : transactionData?.length === 0 ? (
          <div className="text-center my-4">
          <div style={{ maxWidth: 200, margin: "0 auto" }}>
            <Lottie animationData={NoResultAnimation} loop={true} />
          </div>
        </div>
        ) : (
          <div style={{overflowX: "auto", width:"100%"}}>


  <div style={{ minWidth: "950px" }}>
  {transactionData.map((item, idx) => {
    return (
      <Row
        key={idx}
        className="inter-font align-items-start py-3 px-3 border-bottom justify-content-between"
        style={{ fontFamily: "Inter, sans-serif", direction: isRTL ? "rtl" : "ltr" }}
      >
        {/* Date Column */}
        <Col xs={1} className="inter-font mb-3 mb-md-0">
          <div 
            className="inter-font fw-semibold" 
            style={{ textAlign: isRTL ? "right" : "left" }}
          >
            {t("new_text_52")}
          </div>
          <div style={{ 
            direction: "ltr", 
            unicodeBidi: "isolate",
            textAlign: isRTL ? "right" : "left"
          }}>
            {formatSingleDate(item.payment_date)}
          </div>
        </Col>

        {/* Invoice No Column */}
        <Col xs={2} className="inter-font mb-3 mb-md-0">
          <div 
            className="inter-font fw-semibold" 
            style={{ textAlign: isRTL ? "right" : "left" }}
          >
            {t("new_text_58")}
          </div>
          <div style={{ 
            direction: "ltr", 
            unicodeBidi: "isolate",
            textAlign: isRTL ? "right" : "left"
          }}>
            {item.project_code}
          </div>
        </Col>

        {/* Contract Type Column */}
        <Col xs={2} className="inter-font mb-3 mb-md-0">
          <div 
            className="inter-font fw-semibold" 
            style={{ textAlign: isRTL ? "right" : "left" }}
          >
            {t("t_d_text96")}
          </div>
          <div style={{ 
            direction: "ltr", 
            unicodeBidi: "isolate",
            textAlign: isRTL ? "right" : "left"
          }}>
            {item?.talent_type}
          </div>
        </Col>

        {/* Project Title Column */}
        <Col xs={2} className="inter-font mb-3 mb-md-0">
          <div 
            className="inter-font fw-semibold" 
            style={{ textAlign: isRTL ? "right" : "left" }}
          >
            {t("t_d_text95")}
          </div>
          <div style={{ 
            direction: "ltr", 
            unicodeBidi: "isolate",
            textAlign: isRTL ? "right" : "left"
          }}>
            {item.title}
          </div>
        </Col>

        {/* Amount Column */}
        <Col xs={1} className="inter-font mb-3 mb-md-0">
          <div 
            className="inter-font fw-semibold" 
            style={{ textAlign: isRTL ? "right" : "left" }}
          >
            {t("t_d_text85")}
          </div>
          <div style={{ 
            fontSize: "14px", 
            color: "#999",
            direction: "ltr",
            unicodeBidi: "isolate",
            textAlign: isRTL ? "right" : "left"
          }}>
            {item.total_amount} AED
          </div>
        </Col>

        {/* Status Column */}
        <Col xs={1}>
          <div 
            className="inter-font fw-semibold" 
            style={{ textAlign: isRTL ? "right" : "left" }}
          >
            {t("t_d_text83")}
          </div>
          <div 
            className="inter-font d-flex flex-column gap-2 mt-2"
            style={{ 
              alignItems: isRTL ? "flex-end" : "flex-start"
            }}
          >
            <span
              style={{
                background: "#00C25F",
                fontWeight: 500,
                width: "50px",
                height: "22px",
                fontSize: "10px",
                color: "white",
                borderRadius: "4px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                direction: "ltr",
                unicodeBidi: "isolate"
              }}
            >
              {item.pay_status}
            </span>
            <span
              style={{
                fontSize: "12px",
                color: "#495057",
                fontWeight: 500,
                direction: "ltr",
                unicodeBidi: "isolate",
                textAlign: isRTL ? "right" : "left"
              }}
            >
              {item.payment_method}
            </span>
          </div>
        </Col>

        {/* Actions Column */}
        <Col xs={1}>
          <div 
            className="inter-font d-flex flex-wrap align-items-center gap-2 mt-2"
            style={{ 
              justifyContent: isRTL ? "flex-start" : "flex-end",
              flexDirection: isRTL ? "row-reverse" : "row"
            }}
          >
            <LuDownload
              fontSize={20}
              style={{ cursor: "pointer", color: "gray" }}
              onClick={() => {
                if (item?.talents[0].receipt) {
                  window.open(item.talents[0].receipt, "_blank");
                } else {
                  alert("No receipt available.");
                }
              }}
            />
            <FaEye
              fontSize={20}
              style={{ cursor: "pointer", color: "gray" }}
              onClick={() => {
                setSelectedTransaction({ item });
                setShowDetailsModal(true);
              }}
            />
          </div>
        </Col>
      </Row>
    );
  })}
</div>
          
        </div>
      )
        
        
        }
<Modal
  show={showDetailsModal}
  onHide={() => setShowDetailsModal(false)}
  centered
  size="lg"
  dir={isRTL ? "rtl" : "ltr"} // Set direction based on language
>
  <Modal.Header 
    closeButton 
    style={{ 
      background: "#F8F9FA",
      direction: isRTL ? "rtl" : "ltr"
    }}
  >
    <Modal.Title 
      className="inter-font fw-semibold" 
      style={{ 
        textAlign: isRTL ? "right" : "left",
        width: "100%"
      }}
    >
      {t("new_text_59")}
    </Modal.Title>
  </Modal.Header>
  
  <Modal.Body style={{ 
    background: "#FFF",
    direction: isRTL ? "rtl" : "ltr"
  }}>
    {selectedTransaction && (
      <div 
        className="inter-font" 
        style={{ 
          fontSize: "14px",
          textAlign: isRTL ? "right" : "left"
        }}
      >
        {/* Dynamic data with proper text isolation */}
        <p style={{ 
          direction: "ltr", 
          unicodeBidi: "isolate",
          textAlign: isRTL ? "right" : "left"
        }}>
          <strong>{t("c_t_text1")}:</strong> {selectedTransaction.item?.title}
        </p>
        
        <p style={{ 
          direction: "ltr", 
          unicodeBidi: "isolate",
          textAlign: isRTL ? "right" : "left"
        }}>
          <strong>{t("new_text_58")}:</strong> {selectedTransaction.item?.project_code}
        </p>
        
        <p style={{ 
          direction: "ltr", 
          unicodeBidi: "isolate",
          textAlign: isRTL ? "right" : "left"
        }}>
          <strong>{t("t_d_text80")}:</strong> {selectedTransaction.item?.talent_type}
        </p>
        
        {/* Amount with proper currency display */}
        <p style={{ 
          direction: "ltr", 
          unicodeBidi: "isolate",
          textAlign: isRTL ? "right" : "left"
        }}>
          <strong>{t("new_text_56")}:</strong> 
          <span style={{ direction: "ltr", unicodeBidi: "isolate" }}>
            {selectedTransaction.item?.total_amount} AED
          </span>
        </p>
        
        <p style={{ 
          direction: "ltr", 
          unicodeBidi: "isolate",
          textAlign: isRTL ? "right" : "left"
        }}>
          <strong>{t("new_text_57")}:</strong> {selectedTransaction.item?.pay_status}
        </p>

        <hr />

        <p style={{ 
          direction: "ltr", 
          unicodeBidi: "isolate",
          textAlign: isRTL ? "right" : "left"
        }}>
          <strong>{t("new_text_58")}:</strong> {selectedTransaction.item?.transaction_id}
        </p>
        
        <p style={{ 
          direction: "ltr", 
          unicodeBidi: "isolate",
          textAlign: isRTL ? "right" : "left"
        }}>
          <strong>{t("new_text_54")}:</strong> {selectedTransaction.item?.payment_method}
        </p>
        
        <p style={{ 
          direction: "ltr", 
          unicodeBidi: "isolate",
          textAlign: isRTL ? "right" : "left"
        }}>
          <strong>{t("new_text_57")}:</strong> {selectedTransaction.item?.pay_status}
        </p>
        
        <p style={{ 
          direction: "ltr", 
          unicodeBidi: "isolate",
          textAlign: isRTL ? "right" : "left"
        }}>
          <strong>{t("new_text_52")}:</strong> {new Date(selectedTransaction.item?.payment_date).toLocaleString()}
        </p>
      </div>
    )}
  </Modal.Body>
  
  <Modal.Footer style={{ 
    background: "#F8F9FA",
    direction: isRTL ? "rtl" : "ltr"
  }}>
    <Button
      variant="secondary"
      className="inter-font"
      onClick={() => setShowDetailsModal(false)}
    >
      {isRTL ? "إغلاق" : "Close"}
    </Button>
  </Modal.Footer>
</Modal>


      </Container>

        {/* Pagination */}
        {pagination?.total_pages > 1 && (
                <Paginator
                    page={pagination.current_page}
                    rows={pagination.per_page}
                    totalRecords={pagination.total_records}
                    onPageChange={handlePageChange}
                />
            )}
    </div>
  );
};

export default Transaction;
